module.exports = __webpack_public_path__ + "img/step19_a_printer_basic_fix_screws.cf9709cd.png";